import isFunction from 'lodash/isFunction';
import forEach from 'lodash/forEach';
import isArray from 'lodash/isArray';
import './simpleBlindSelector.scss';

class SimpleBlindSelectorCtrl {
    constructor($sce, imagesService, dataService, apiService, $scope, $rootScope) {
        if (angular.isUndefined(this.multiSelect)) {
            this.multiSelect = false;
        }

        if (angular.isUndefined(this.selectedOptions)) {
            this.selectedOptions = [];
        }
        this.moreInfo = null;
        this.sce = $sce;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.imagesService = imagesService;
        this.dataService = dataService;
        this.apiService = apiService;
    }

    isSelected(id) {
        if (isArray(this.selectedOptions)) {
            return this.selectedOptions.indexOf(id) !== -1;
        }

        return this.selectedOptions == id; // eslint-disable-line eqeqeq
    }

    /**
     * Reset button functionality
     */
    reset() {
        this.selectedOptions = this.dataService.reset(
            this.defaultSelectedIdFieldName,
        );
    }

    getOptions() {
        return this.options;
    }

    onInit() {
        this.moreInfo = this.dataService.getMoreInfo(this.defaultSelectedIdFieldName);
        this.trustHtml();
    }

    trustHtml() {
        forEach(this.options, (el) => {
            if (angular.isDefined(el.attributes.subtitle)) {
                this.sce.trustAsHtml(el.attributes.subtitle);
            }
        });
    }

    closeBox() {
        if (isFunction(this.closeBoxCallback)) {
            this.closeBoxCallback();
        }
        this.selectedOptions = [];
    }

    toggleSelected(id) {
        this.selectedOptions = [id];
        this.dataService.updateSelectedOptions(
            this.defaultSelectedIdFieldName,
            this.selectedOptions,
            this.options[0].type,
            true,
        );
    }

    getCaptionImage(type) {
        return this.imagesService.getCaptionImageUrl(this.defaultSelectedIdFieldName, type);
    }

    getImage(imgSrc) {
        return this.imagesService.getFullUrl(imgSrc);
    }

    setImage($event, imgSrc) {
        $($event.target).parent().find('.simpleBlindSelect__content-item-icon-hover').attr('src', this.getImage(imgSrc));
    }
}

SimpleBlindSelectorCtrl.$inject = ['$sce', 'imagesService', 'dataService', 'handlesService', 'apiService', '$scope', '$rootScope'];

export default SimpleBlindSelectorCtrl;
